import { AddressInput } from 'lib/types'
import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { EnumType, jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

interface Address {
  city: string
  country_id: EnumType
  default_shipping: boolean
  default_billing: boolean
  firstname: string
  lastname: string
  company?: string
  postcode: string
  region: {
    region: string
    region_id: number
    region_code: string
  }
  street: Array<string | undefined>
  telephone: string
  [key: string]: any
}

export interface CreateCustomerAddressMutationObject {
  mutation: {
    createCustomerAddress: {
      __args: {
        input: Address | null
      }
      id: boolean
      customer_id: boolean
      region: {
        region: boolean
        region_id: boolean
        region_code: boolean
      }
      country_id: boolean
      street: boolean
      telephone: boolean
      postcode: boolean
      city: boolean
      default_shipping: boolean
      default_billing: boolean
    }
  }
}

export const createCustomerAddressMutationObject: CreateCustomerAddressMutationObject = {
  mutation: {
    createCustomerAddress: {
      __args: {
        input: null
      },
      id: true,
      customer_id: true,
      region: {
        region: true,
        region_id: true,
        region_code: true
      },
      country_id: true,
      street: true,
      telephone: true,
      postcode: true,
      city: true,
      default_shipping: true,
      default_billing: true
    }
  }
}

interface CreateCustomerAddressMutationInput {
  payload: AddressInput
}

export type CreateCustomerAddressMutation = (input: CreateCustomerAddressMutationInput) => Promise<FetchResult<any>>

export const createCreateCustomerAddressMutation = ({ getMutations }: ServiceDependencies): CreateCustomerAddressMutation => async ({ payload }) => {
  const { city, countryCode, isDefaultShipping, isDefaultBilling, firstName, lastName, company, postalCode, region, regionId, regionCode, street, street2, phoneNumber, ...rest } = payload

  const mutation = getMutations().createCustomerAddressMutation
  const address: Address = {
    city,
    country_id: new EnumType(countryCode),
    default_shipping: isDefaultShipping,
    default_billing: isDefaultBilling,
    firstname: firstName,
    lastname: lastName,
    company,
    postcode: postalCode,
    region: {
      region,
      region_id: regionId,
      region_code: regionCode
    },
    street: [street, street2],
    telephone: phoneNumber,
    ...rest
  }

  mutation.mutation.createCustomerAddress.__args.input = address

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
